import { render } from "./ArrowButton.vue?vue&type=template&id=708cc179&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"

import "./ArrowButton.vue?vue&type=style&index=0&id=708cc179&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708cc179"]])

export default __exports__